import React from 'react';
import { Select, MenuItem } from '@mui/material';

export const formatGraphDayLabel = (day) => {
    if (!day) {
        return '';
    }
    const date = new Date(day);
    if (isNaN(date.getTime())) {
        return String(day);
    }
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

/**
 * Seletor de dia dos gráficos.
 * Na tela: Select do MUI.
 * Na impressão: texto simples (o Select não clona o valor no react-to-print).
 */
const GraphDaySelect = ({ selectedDay, uniqueDays, onChange, isPrinting }) => {
    if (isPrinting) {
        if (!selectedDay) {
            return null;
        }
        return (
            <div
                style={{
                    marginBottom: 12,
                    fontFamily: 'Arial, sans-serif',
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#000',
                }}
            >
                Dia: {formatGraphDayLabel(selectedDay)}
            </div>
        );
    }

    return (
        <Select
            className="no-print"
            value={selectedDay}
            onChange={onChange}
            style={{ marginBottom: '10px' }}
        >
            {uniqueDays.map((day) => (
                <MenuItem key={day} value={day}>
                    {formatGraphDayLabel(day)}
                </MenuItem>
            ))}
        </Select>
    );
};

export default GraphDaySelect;
